export function validateOnNumber(el) {
  if (Number(el.value) > 0) {
    return true;
  } else {
    return false;
  }
}
export function validateOnEmpty(el) {
  if (el.value !== "") {
    return true;
  } else {
    return false;
  }
}
export function validateOnText(el) {
  if (el.innerText !== "") {
    return true;
  } else {
    return false;
  }
}
export function validateOnNull(el) {
  if (el !== null) {
    return true;
  } else {
    return false;
  }
}
export function validateEmail(email) {
  var reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (reg.test(email.value)) {
    return true;
  } else {
    return false;
  }
}
export function getChecboxActive(elementId) {
  if (elementId.classList.contains("active")) {
    return true;
  } else {
    return false;
  }
}
export function createErrorsMsg(obj) {
  let strErrors = "";
  for (let key in obj) {
    strErrors = strErrors + "\n" + obj[key];
  }
  strErrors = strErrors.trimStart();
  console.log(strErrors);
  return strErrors;
}
export function showMsg(elMsg, textMsg) {
  let blockMsg = document.getElementById(elMsg);
  blockMsg.innerText = textMsg;
  blockMsg.classList.add("show_msg");
  setTimeout(function () {
    blockMsg.classList.remove("show_msg");
  }, 6000);
}
